import { AuthApi } from 'api/AuthApi';
import { authApiClient } from 'container/authApiClient';

export const authApi = new AuthApi(authApiClient);
